export function sortAppointmentTypes (appointmentTypes) {
    // Ordena uma cópia: Array.prototype.sort() muta in-place. Como o cache do
    // SGHService devolve a mesma referência que fica no state reativo do Vuex,
    // ordenar o array original violaria o strict mode ("do not mutate vuex
    // store state outside mutation handlers").
    //
    // O campo de nome vem como "NOME" (DTO usa @JsonProperty("NOME")); ordenar
    // por "name" era no-op. localeCompare pt-BR ordena alfabeticamente ignorando
    // caixa e acentos.
    return [...appointmentTypes].sort((a, b) =>
        (a.NOME || '').localeCompare(b.NOME || '', 'pt-BR', { sensitivity: 'base' })
    )
}